import strings from '../../Localization/Localization';

import { form as _previousPricesForm } from './creditPackPreviousPrices';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.creditPack.name.label,
  validators: []
}

let quantity = {
  fieldKey: "quantity",
  type: "text",
  label: strings.form.creditPack.quantity.label,
  validators: []
}

let quantityFree = {
  fieldKey: "quantity_free",
  type: "text",
  label: strings.form.creditPack.quantityFree.label,
  defaultValue: 0,
  validators: []
}

let price = {
  fieldKey: "price",
  type: "price",
  label: strings.form.creditPack.price.label,
  validators: []
}

let available = {
  fieldKey: "available",
  type: "switch",
  label: strings.form.creditPack.available.label,
  validators: []
}

let lastPriceModifiedAt = {
  fieldKey: "last_price_modified_at",
  type: "date",
  label: strings.form.creditPack.lastPriceModifiedAt.label,
  validators: []
}

let previousPrices = {
  fieldKey: "previous_prices",
  type: "array",
  label: "",

  validators: [],

  allowMoreField: false,
  defaultNumberOfField: 0,

  subField: {
    type: "subform",
    label: "Prix #key#",

    validators: [],

    subForm: _previousPricesForm,
  }
}

export const previousPricesForm = {
  formKey: "creditPack",
  fields: [
    quantity,
    quantityFree,
    price,
    lastPriceModifiedAt,
    previousPrices
  ]
}

export const form = {
  formKey: "creditPack",
  fields: [
    name,
    quantity,
    quantityFree,
    price,
    available
  ]
}
